module.exports = __webpack_public_path__ + "static/img/mp.6258bd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr/mp.png
// module id = 4Zm2
// module chunks = 26